<template>
    <div>
        <div class="col-lg-12">
            <form class="needs-validation" autocomplete="off">
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingTargetProduct.titleBlock') }} </label>
                    <div class="col-sm-9">
                        {{ dataForm.block_target_product.title_block }}
                        <div class="mt-3">
                            <div class="form-group row">
                                <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.setSizeText') }}</label>
                                <div class="col-sm-3">
                                    <div class="d-flex align-items-center" style="gap: 0.5rem">
                                        {{ `${dataForm.block_target_product.size_title}px` }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.colorText') }}</label>
                                <div class="col-sm-3">
                                    <InputText
                                        style="max-width: 100px"
                                        :model.sync="dataForm.block_target_product.color_title"
                                        :config="{
                                            type: 'color',
                                            classCustom: 'form-control-color',
                                            error: false
                                        }"
                                        disabled
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.backgroundText') }}</label>
                                <div class="col-sm-3">
                                    <InputText
                                        style="max-width: 100px"
                                        :model.sync="dataForm.block_target_product.background_title"
                                        :config="{
                                            type: 'color',
                                            classCustom: 'form-control-color',
                                            error: false
                                        }"
                                        disabled
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 170px">{{ $t('landingPage.settingPrize.imgTitleLPforPrize') }}</label>
                    <div class="col-sm-10">
                        <div v-if="dataForm.block_target_product.title_image?.path" style="width: 200px; height: 200px" class="position-relative">
                            <b-img
                                class=""
                                thumbnail
                                fluid
                                :src="dataForm.block_target_product.title_image?.path"
                                :alt="dataForm.block_target_product.title_image.origin_name"
                                style="width: 100%; height: 100%; object-fit: cover; object-position: center; border-radius: 10px"
                            ></b-img>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingTargetProduct.backgroundBlock') }}</label>

                    <div class="col-sm-10">
                        <div>
                            <div
                                v-if="dataForm.block_target_product.background_image?.path"
                                style="width: 200px; height: 200px"
                                class="position-relative"
                            >
                                <b-img
                                    class=""
                                    thumbnail
                                    fluid
                                    :src="dataForm.block_target_product.background_image?.path"
                                    :alt="dataForm.block_target_product.background_image.origin_name"
                                    style="width: 100%; height: 100%; object-fit: cover; object-position: center; border-radius: 10px"
                                ></b-img>
                            </div>
                        </div>
                        <div class="my-3">
                            <InputText
                                style="max-width: 100px"
                                :model.sync="dataForm.block_target_product.background_color"
                                :config="{
                                    type: 'color',
                                    classCustom: 'form-control-color',
                                    error: false
                                }"
                                disabled
                            />
                        </div>
                        <div>
                            <InputCheckBox
                                :model.sync="dataForm.block_target_product.is_repeat"
                                :id="`check-repeat-background-target__product`"
                                :value="dataForm.block_target_product.is_repeat"
                                :label="`repeat`"
                                disabled
                            />
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingTargetProduct.styleBlock') }} </label>
                    <div class="col-sm-10">
                        <div style="width: 100px; height: 80px">
                            <img
                                class="w-100 h-100"
                                style="object-fit: cover"
                                :src="dataForm.block_target_product.style?.image_preview"
                                :alt="dataForm.block_target_product.style?.image_preview"
                            />
                        </div>

                        <div class="mt-3 body__preview">
                            <div
                                class="block_target_product"
                                :style="`background-color: ${dataForm.block_target_product?.background_color ?? ''};
                                        background-image: url(${dataForm.block_target_product?.background_image?.path ?? ''});
                                        background-repeat: ${dataForm.block_target_product?.is_repeat ? 'repeat' : 'no-repeat'};`"
                            >
                                <div :class="`__${dataForm.block_target_product.style?.id}`">
                                    <div class="target_product">
                                        <div v-if="dataForm.block_target_product.title_image?.path" class="mb-5">
                                            <img
                                                :src="dataForm.block_target_product.title_image.path"
                                                :alt="dataForm.block_target_product.title_image.path"
                                                class="img__title"
                                            />
                                        </div>

                                        <div v-else style="padding-top: 5rem">
                                            <h2
                                                v-if="STYLE_SHOW_TITLE.includes(dataForm.block_target_product.style?.id)"
                                                class="title-common"
                                                :style="`background: ${dataForm.block_target_product?.background_title ?? ''};
                                                color:  ${dataForm.block_target_product?.color_title ?? ''};
                                                font-size: ${dataForm.block_target_product?.size_title}px;`"
                                            >
                                                <span>{{ dataForm.block_target_product.title_block }}</span>
                                            </h2>
                                            <h2 v-else class="title-common">
                                                <div
                                                    class="title-eng"
                                                    :style="`background: ${dataForm.block_target_product?.background_title ?? ''};
                                                    color:  ${dataForm.block_target_product?.color_title ?? ''};
                                                    font-size: ${dataForm.block_target_product?.size_title}px;`"
                                                >
                                                    <span>{{ dataForm.block_target_product.title_block }}</span>
                                                </div>
                                                <!-- <div class="title-jp"></div> -->
                                            </h2>
                                        </div>
                                        <div v-html="dataForm.block_target_product.html_content"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { handleDownFile } from '@/utils/format';
import { InputText, InputCheckBox } from '@/components/Input';
import { STYLE_SHOW_TITLE } from '../../../constants';

export default {
    name: 'settingTargetProduct',
    components: { InputText, InputCheckBox },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        }
    },
    data() {
        return {
            STYLE_SHOW_TITLE: STYLE_SHOW_TITLE
        };
    },
    methods: {
        downLoadFile(path, name) {
            if (path) return handleDownFile(path, name);
        }
    }
};
</script>

<style lang="scss" scoped></style>
